<template>
  <div class="Main-Inner">
    <div class="Main-Content">
      <Page :title="$t('notEnabled.Welcome!')" style="background-color: #eee;">
        <Layout>
          <LayoutSection>

            <Card>
              <CardSection>
                <div v-if="!isAgency" v-html="$t('notEnabled.descAgency')"></div>
                <div v-else v-html="$t('notEnabled.desc')"></div>
              </CardSection>
            </Card>

            <img id="welcomeImage" src="https://static.fanplayr.com/portal/assets/images/dashboard-empty-state.png" />

          </LayoutSection>
        </Layout>
      </Page>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotEnabled'
}
</script>

<style lang="scss" scoped>
#welcomeImage {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 45px;
}
</style>